import React from "react"
import styled, { keyframes } from "styled-components"

export default function PreLaunch({ start, duration }: any) {
  let perc = ((start - 1) / (duration - 2)) * 100
  let finalPercent = perc > 100 ? 100 : perc
  return (
    <PrelaunchWrapper fade={start === 8} percent={finalPercent}>
      <div>NEXT LAUNCH</div>
      <ProgressBar />
    </PrelaunchWrapper>
  )
}

const fadeOut = keyframes`
  0% { margin-top: 102px; opacity: 1; }
  100% { margin-top: 90px; opacity: 0; }
`

const PrelaunchWrapper = styled.div<{ fade: boolean; percent: number }>`
  position: absolute;
  margin-top: 102px;
  opacity: 1;
  animation-name: ${({ fade }) => fade && fadeOut};
  animation-duration: 0.4s;
  animation-delay: 0.6s;
  animation-fill-mode: forwards;
  .back {
    margin-top: 13px;
    position: absolute;
    background: #301e56;
    width: 156px;
    height: 6px;
    border-radius: 100px;
  }
  .forward {
    margin-top: 13px;
    position: absolute;
    background: #ffb000;
    width: ${({ percent }) => percent}%;
    height: 6px;
    border-radius: 100px;
    transition: width 1.8s;
  }
`

function ProgressBar() {
  return (
    <>
      <div className="back"></div>
      <div className="forward"></div>
    </>
  )
}
